import {
  ACTIVATE_ALL_PRESELECTED_FILTERS,
  ACTIVATE_PRESELECTED_FILTER,
  ACTIVE_FILTER_NUM,
  CLEAR_ALL_FILTERS,
  POPULATE_NEXT_PRODUCT_PAGE,
  SET_ACTIVE_FILTERS,
  TOGGLE_FILTER,
} from "./VideoLibraryTypes";
import { fetchAllPosts } from "./VideoLibraryActions";
import { triggerSearchApiCall, resetPageCount } from "../search/SearchActions";

function isFilterAction(action) {
  return (
    action.type === TOGGLE_FILTER ||
    action.type === ACTIVATE_PRESELECTED_FILTER ||
    action.type === ACTIVATE_ALL_PRESELECTED_FILTERS ||
    action.type === POPULATE_NEXT_PRODUCT_PAGE ||
    action.type === CLEAR_ALL_FILTERS
  );
}

function isPageResetAction(action) {
  return (
    action.type === ACTIVATE_PRESELECTED_FILTER ||
    action.type === ACTIVATE_ALL_PRESELECTED_FILTERS ||
    action.type === CLEAR_ALL_FILTERS
  );
}

function filterOutNonActive(list) {
  return list
    .filter((item) => {
      return item.active;
    })
    .map((item) => {
      return item.value;
    })
    .join(",");
}

function getActiveFilters(state) {
  return {
    languages: filterOutNonActive(state.languageFilters),
    topics: filterOutNonActive(state.topicFilters),
    typology: filterOutNonActive(state.typologyFilters),
    countries: filterOutNonActive(state.countryFilters),
  };
}

function getFilterAmount(value, isTag) {
  return filterOutNonActive(value, isTag) ? filterOutNonActive(value, isTag).split(",").length : 0;
}

function getFilterLength(state) {
  const countLanguage = getFilterAmount(state.languageFilters);
  const countTopic = getFilterAmount(state.topicFilters);
  const countTypology = getFilterAmount(state.typologyFilters);
  const countCountry = getFilterAmount(state.countryFilters);
  return {
    languages: countLanguage,
    topics: countTopic,
    typology: countTypology,
    countries: countCountry,
    total: countLanguage + countTopic + countTypology + countCountry,
  };
}

const videoLibraryFilterListener = (store) => (next) => (action) => {
  const result = next(action);
  const isSearch = action.value && action.value.isSearch;

  if (isPageResetAction(action) && isSearch) {
    store.dispatch(resetPageCount());
  }

  if (isFilterAction(action)) {
    const activeFilters = getActiveFilters(store.getState().videoLibrary);
    const activeFilterNum = getFilterLength(store.getState().videoLibrary);
    store.dispatch({ type: SET_ACTIVE_FILTERS, value: activeFilters });
    store.dispatch({ type: ACTIVE_FILTER_NUM, value: activeFilterNum });

    const isFirstLoad = action?.value && action?.value?.firstLoad;
    if (!isFirstLoad) {
      if (isSearch) {
        const searchQuery = store.getState().search.query;
        const { page } = store.getState().search;
        triggerSearchApiCall(store.dispatch, searchQuery, false, true, page, 12, "VIDEO LIBRARY");
      } else {
        const { page } = store.getState().videoLibrary;
        fetchAllPosts(store.dispatch, true, page);
      }
    }
  }

  return result;
};

export default videoLibraryFilterListener;
